<template>
  <div id="tela-selfie">
    <div class="captura" :class="{'hidden':isError}">
      <div id="liveness-caf"></div>
    </div>

    <div class="page-error margem-app">
      <Error
          v-if="isError"
          :title="error.title"
          :subtitle="error.subtitle"
          :button-text="error.btnTitle"
          v-bind:callback="this.reloadComponent"
      ></Error>
    </div>
  </div>

</template>

<script>

import Error from "../shared/Error";
import AppService from "../../services/AppService";
import LivenessLogService from "../../services/LivenessLogService";
import jwtDecode from "jwt-decode";

const ERROR = {
  title: "Não conseguimos tirar a foto do seu rosto",
  subtitle: "Não localizamos seu rosto para tirar a foto. Centralize ele na moldura e tente novamente",
  btnTitle: "Tentar novamente",
};

const ERROR_ACESSO_CAMERA = {
  title: "Algo deu errado ao acessar sua câmera",
  subtitle: "Precisamos do acesso pra tirar a foto e confirmar sua identidade",
  btnTitle: "Permitir acesso à câmera",
};
const EVENTS_CAF = {
  started: 'started',
  sdk_button_ready:'sdk-button-ready',
  passed: 'passed',
  failed:'failed',
  error:'error',
  streaming: 'streaming',
  streamed: 'streamed',
  canceled: 'canceled',
  permission: 'permission',
  permission_denied: 'permission_denied',
  unsupported:'unsupported'
};

export default {
  name: "LivenessCaf",
  components: {Error},
  data(){
    return {
      isError: false,
      error: {
        title: ERROR.title,
        subtitle: ERROR.subtitle,
        btnTitle: ERROR.btnTitle
      },
      options:{
        settings: {
          filter: 'clear',
          language: 'pt_BR'
        },
        permissionButton: {
          label: ERROR_ACESSO_CAMERA.btnTitle,
          color: '#fff',
          backgroundColor: '#660099',
          borderRadius: '24px',
          border: '1px solid transparent'
        },
        startButton: {
          label: 'Estou Pronto',
          color: '#fff',
          backgroundColor: '#660099',
          borderRadius: '24px',
          border: '1px solid transparent'
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.listenerEvents());
  },
  beforeRouteLeave(to, from,next) {
    this.removeListeners();
    next();
  },
  created() {
    this.$store.dispatch("setTitulo", "Confirmar identidade");
    this.$store.dispatch("setLoadingStatus", true);
  },
  mounted() {
    this.logLivenessService = new LivenessLogService();
    this.appService = new AppService();
    this.appService.carregarComponentSelefie();
    var interval = setInterval(_ => {
      if (!this.$store.getters.componenteSelfieCarregado) {
        return;
      }
      this.selfie = window.selfie;
      this.iniciarSelfie();
      clearInterval(interval);
    }, 100);
  },
  methods:{
    iniciarSelfie:async function (){
      const token = this.$store.state.token_caf;
      const data = jwtDecode(token);
      const sdk = window['FacesSDK'];

      if(process.env.APPLICATION_ENVIRONMENT !== 'production'){
        this.options.environment = 'beta';
      }

      const facesSdk = await sdk.initializeSdk(token, 'liveness-caf', false, data.peopleId, this.options);
      this.waitResult(facesSdk);
    },
    handleEvents(event){
      switch (event.type){
        case EVENTS_CAF.permission:
        case EVENTS_CAF.sdk_button_ready:
          this.$store.dispatch("setLoadingStatus", false);
          break;
        case EVENTS_CAF.passed:
          this.$store.dispatch("setLoadingStatus", true);
          break;
        case EVENTS_CAF.permission_denied:
          let e = ERROR_ACESSO_CAMERA;
          this.showError(e.title,e.subtitle,e.btnTitle);
          break;
        case EVENTS_CAF.unsupported:
        case EVENTS_CAF.canceled:
        case EVENTS_CAF.failed:
        case EVENTS_CAF.error:
          this.showError(null,event.detail.reason);
          break;
      }
    },
    async waitResult(facetekSdk){
      const result = await facetekSdk.execute();
      const signedResponse = result.signedResponse;
      const dataSignedResponse = jwtDecode(signedResponse);
      if(!dataSignedResponse.isAlive){
        this.showError();
        return;
      }
      sessionStorage.setItem("s", signedResponse);
      sessionStorage.setItem("iscaf", true);
      this.nextPage();
    },
    listenerEvents(){
      Object.values(EVENTS_CAF).forEach(eventType => {
        document.addEventListener(eventType, this.handleEvents);
      });
    },
    removeListeners(){
      Object.values(EVENTS_CAF).forEach(eventType => {
        document.removeEventListener(eventType,this.handleEvents);
      });
    },
    reloadComponent() {
      this.$store.dispatch("setLoadingStatus", true);
      this.$router.replace({name:'ConfirmarIdentidade'});
    },
    nextPage(){
      this.appService.nextPageLiveness();
    },
    showError(title,subtitle,btnTitle) {
      if (this.isError) {
        return;
      }
      this.error.title = title ? title : ERROR.title;
      this.error.subtitle = subtitle ? subtitle : ERROR.subtitle;
      this.error.btnTitle = btnTitle ? btnTitle : ERROR.btnTitle;
      this.isError = true;
      this.$store.dispatch("setLoadingStatus", false);
    },
  }
}
</script>

<style scoped>
#liveness-caf{
  display: flex;
  justify-content: center;
}
.hidden {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/LivenessCaf.vue